import Proposals from "../../Pages/Proposals";

const navigation = {
  header: "",
  links: [
    { text: "Proposals", icon: <></>, route: "proposals", component: Proposals },
    
  ],
};
export default navigation;
